import { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './KitchenMoments.css';

// Import local assets
import masala1 from '../assets/spices3.jpg';
import masala2 from '../assets/masala2.jpg';
import masala3 from '../assets/amchur powder.jpg';
import masala4 from '../assets/black papeer.jpg';
import masala5 from '../assets/turmeric.jpg';
import masala6 from '../assets/spice5.jpg';
import masala7 from '../assets/white pepper1.jpg';

const moments = [
  {
    id: 1,
    title: "The Morning Brew",
    desc: "Starting the day with the warmth of freshly ground ginger and cardamom in every cup.",
    img: masala1,
    size: "wide"
  },
  {
    id: 2,
    title: "Fresh Harvest",
    desc: "Vibrant ingredients met with the purity of hand-sorted spices.",
    img: masala2,
    size: "tall"
  },
  {
    id: 3,
    title: "Sun-Dried Heritage",
    desc: "Patiently waiting for the sun to lock in the flavor of every single chili.",
    img: masala3,
    size: "small"
  },
  {
    id: 4,
    title: "Stone Grinding",
    desc: "Preserving the essential oils through the rhythmic, slow crush of stone.",
    img: masala4,
    size: "small"
  },
  {
    id: 5,
    title: "Secret Recipes",
    desc: "Generations of family wisdom blended into every single gram of masala.",
    img: masala5,
    size: "tall"
  },
  {
    id: 6,
    title: "The Perfect Finish",
    desc: "A final sprinkle that transforms a simple dish into a royal feast.",
    img: masala6,
    size: "wide"
  },
  {
    id: 7,
    title: "Pure Tradition",
    desc: "Every pinch tells a story of authentic flavors and timeless heritage.",
    img: masala7,
    size: "wide"
  }
];

const KitchenMoments = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, -100]);

  return (
    <section className="kitchen-moments" ref={containerRef}>
      <div className="container">
        <div className="moments-header">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <span className="section-tag">Authentic Living</span>
            <h2 className="section-title">Kitchen <span className="gradient-text italic-serif">Moments</span></h2>
          </motion.div>
          <motion.p
            className="moments-sub"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Spices are more than ingredients; they are the memories of our childhood and the flavor of our traditions.
          </motion.p>
        </div>

        <div className="moments-grid">
          {moments.map((moment, i) => (
            <motion.div
              key={moment.id}
              className={`moment-card ${moment.size}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              viewport={{ once: true }}
              data-cursor
            >
              <div className="moment-img-wrap">
                <img src={moment.img} alt={moment.title} />
                <div className="moment-overlay">
                  <div className="moment-content">
                    <h3 className="moment-title">{moment.title}</h3>
                    <p className="moment-desc">{moment.desc}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Background Decorative Text */}
      <motion.div className="moments-bg-text" style={{ y }}>
        LIFESTYLE
      </motion.div>
    </section>
  );
};

export default KitchenMoments;
